/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TExistsUserEstimationScoreFactRequest,
  TExistsUserEstimationScoreFactModel,
  IMappers,
  TExistsUserEstimationScoreFactResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IExistsEstimationScoreFact } from '../../entities/estimation_score_fact/ExistsEstimationScoreFact';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createExistsUserEstimationScoreFactModel(
  parameters: TExistsUserEstimationScoreFactRequest,
): TExistsUserEstimationScoreFactModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'price-estimator',
    pathApi: '/v1/exists-user-estimation-score-fact/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IExistsUserEstimationScoreFactOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TExistsUserEstimationScoreFactRequest;
}

export async function fetchExistsUserEstimationScoreFact<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IExistsUserEstimationScoreFactOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TExistsUserEstimationScoreFactResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createExistsUserEstimationScoreFactModel(parameters),
    config,
  )) as FetchResponse<TExistsUserEstimationScoreFactResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IExistsEstimationScoreFact, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TExistsUserEstimationScoreFactResponse>;
}
